import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: [
    'value',
    'pageid',
    'totalEgg',
    'exceptCashOnDelivery',
    'shippingType',
    'selectedGiveAwayProduct'
  ],
  data: function () {
    return {
      egg_front_url: null,
      errorVoucherCode: '',
      isInputVoucherCode: false,
      hasVoucherCode: false,
      loading: false,
      promocode: null,
      sessiontoken: null,
      userid: null,
      hasError: false,
      discount: null,
      total: null,
      promotion: null,
      dialog: false,
      giveAwayProducts: []
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      currencySign: 'currencySign'
    }),

    codeAll() {
      if (
        this.pageProfile.pageid === '100619629025288' &&
        this.shippingType.type !== 'other_charge'
      ) {
        return this.$store.state.vouchers.filter((el) => el.code !== 'DELIVR')
      } else {
        return this.$store.state.vouchers
      }
    }
  },
  async mounted() {
    const vm = this
    vm.initial()
    if (vm.$route.query.userid) {
      if (['shop', 'shopcommu'].includes(config.env))
        await vm.getPromotionCodeAvailable()
    } else {
      await vm.getSalepagePromotionCodeAvailable()
    }
    await this.$nextTick()
    if (vm.value && vm.value != '') {
      vm.promocode = vm.value
      await vm.onCheckVoucher()
    }
    if (config.env == 'shop') vm.pageConfig()
  },
  methods: {
    initial() {
      const vm = this
      if (vm.$route.query.userid) {
        vm.userid = vm.$route.query.userid
      }
      if (vm.$route.query.sessiontoken) {
        vm.sessiontoken = vm.$route.query.sessiontoken
      }
    },
    dateFormat(dateTime) {
      return dateTime !== null
        ? moment(dateTime).format('DD/MM/YYYY - hh.mm')
        : '-'
    },
    async selectPromoCode(code) {
      this.promocode = code
      this.dialog = false
      await this.onCheckVoucher()
    },

    async getSalepagePromotionCodeAvailable() {
      const vm = this
      try {
        if (localStorage.getItem('cartarray') && this.userid == null) {
          var response = await axios.post(
            `${config.getConfig('serverUrl')}sale_page/${
              vm.pageProfile.pageid
            }/promo-code-list`,
            {
              cart_data: JSON.parse(localStorage.getItem('cartarray'))
            }
          )
          vm.$store.commit('SET_VOUCHERS', response.data.data)
          if (['nestle'].includes(vm.pageProfile.type)) {
            if (vm.$store.state.hasAutoSelectVoucher == false) {
              vm.$store.commit('SET_HAS_AUTO_SELECT_VOUCHER', true)
              if (
                vm.$store.state.vouchers &&
                vm.$store.state.vouchers.length > 0
              ) {
                const voucher = vm.$store.state.vouchers.find((v) => {
                  return v.discounttype == 'giveaway'
                })
                const mostDiscount = vm.$store.state.vouchers.reduce(
                  (prev, curr) => {
                    if (prev == null) return curr
                    try {
                      return parseFloat(prev.discountvalue) <
                        parseFloat(curr.discountvalue)
                        ? curr
                        : prev
                    } catch (error) {
                      return prev
                    }
                  },
                  null
                )
                const selectedVoucher = voucher || mostDiscount

                if (selectedVoucher) vm.selectPromoCode(selectedVoucher.code)
              }
            }
          }
        }
      } catch (error) {
        vm.$store.commit('SET_VOUCHERS', [])
      }
    },
    async getPromotionCodeAvailable() {
      const vm = this
      let params = { pageid: vm.pageProfile.pageid, userid: vm.userid }
      if (vm.$route.query && vm.$route.query.shoptoken) {
        params.shop_token = vm.$route.query.shoptoken
      }
      try {
        var response = await axios.get(
          `${config.getConfig('serverUrl')}get_promotion_code_available`,
          {
            params: params
          }
        )
        vm.$store.commit('SET_VOUCHERS', response.data.data)
        if (['nestle'].includes(vm.pageProfile.type)) {
          if (vm.$store.state.hasAutoSelectVoucher == false) {
            vm.$store.commit('SET_HAS_AUTO_SELECT_VOUCHER', true)
            if (
              vm.$store.state.vouchers &&
              vm.$store.state.vouchers.length > 0
            ) {
              const voucher = vm.$store.state.vouchers.find((v) => {
                return v.discounttype == 'giveaway'
              })
              const mostDiscount = vm.$store.state.vouchers.reduce(
                (prev, curr) => {
                  if (prev == null) return curr
                  try {
                    return parseFloat(prev.discountvalue) <
                      parseFloat(curr.discountvalue)
                      ? curr
                      : prev
                  } catch (error) {
                    return prev
                  }
                },
                null
              )
              const selectedVoucher = voucher || mostDiscount

              if (selectedVoucher) vm.selectPromoCode(selectedVoucher.code)
            }
          }
        }
      } catch (error) {
        vm.$store.commit('SET_VOUCHERS', [])
      }
    },
    async onCheckVoucher() {
      if (this.pageProfile && this.pageProfile.egg_crm_status) {
        await this.eggCheckCode()
      } else {
        await this.getCalculateWithPromocode()
      }
    },
    getCalculateWithPromocode: async function () {
      const vm = this
      if (!vm.cart || vm.cart.length == 0 || vm.isCartOutOfStock) {
        return false
      }

      vm.loading = true
      let data = {}
      let url
      let serverUrl =
        vm.pageProfile.type == 'thaiairways'
          ? `${config.thaiairways.serverUrl}`
          : `${config.getConfig('serverUrl')}`
      if (!this.promocode || (this.promocode && !this.promocode.trim())) {
        return false
      }
      if (localStorage.getItem('cartarray') && this.userid == null) {
        data = {
          promocode: this.promocode.toUpperCase(),
          cart_data: []
        }
        data.cart_data = JSON.parse(localStorage.getItem('cartarray')).map(
          function (val) {
            return {
              productid: val.productid,
              quantity: val.quantity,
              option: val.option,
              categoryid: val.categoryid,
              price: val.discountprice
            }
          }
        )
        url = `${config.getConfig('serverUrl')}sale_page/${
          this.pageProfile.pageid
        }/check_promo_code`

        this.handleGetVoucher(url, data)
      } else if (vm.userid && vm.sessiontoken) {
        data = {
          promocode: this.pageProfile.egg_crm_status
            ? vm.promocode
            : vm.promocode.toUpperCase(),
          cartarray: []
        }
        if (vm.$route.query && vm.$route.query.shoptoken) {
          data.shop_token = vm.$route.query.shoptoken
        }
        if (vm.cart) {
          data.cartarray = vm.cart.map(function (val) {
            return { pid: val.id, qty: val.quantity, option: val.option }
          })
        }
        url = `${serverUrl}calculatewithpromocode?pageid=${vm.pageProfile.pageid}`
        if (
          vm.userid != null &&
          vm.sessiontoken != null &&
          vm.userid != '' &&
          vm.sessiontoken != ''
        ) {
          url += '&userid=' + vm.userid + '&sessiontoken=' + vm.sessiontoken
        }

        if (vm.$route.query.admintoken) {
          data.admin_jwt = vm.$route.query.admintoken
        }

        this.handleGetVoucher(url, data)
      }
    },
    async handleGetVoucher(url, data) {
      const vm = this
      try {
        const response = await axios.post(url, data)

        if (
          this.pageProfile.pageid === '100619629025288' &&
          this.shippingType.type !== 'other_charge'
        ) {
          response.data.responsecode = false
        }

        if (response.status == 200 && response.data.responsecode == 200) {
          window.fbq('track', 'PromoCode', vm.promocode.toUpperCase())
          window.ttq.track('PromoCode', vm.promocode.toUpperCase())
          window.gtag('event', 'PromoCode', vm.promocode.toUpperCase())
          window.dataLayer.push({ PromoCode: vm.promocode.toUpperCase() })
          let result = response.data
          if (result.promoobj && result.promoobj.length > 0) {
            result.promocodeby = 'zwiz'
            vm.$emit('onUpdateTotal', {
              ...result,
              onUpdate: function () {
                // vm.onCheckVoucher()
              }
            })
            vm.discount = Math.floor(result.discount)
            vm.total = result.total
            vm.promotion = result
            vm.promotion.discount = vm.discount
            vm.hasVoucherCode = true
            vm.isInputVoucherCode = false

            if (result.giveaway) {
              this.giveAwayProducts = result.giveaway
              if (this.selectedGiveAwayProduct) {
                this.selectedGiveAwayProduct =
                  this.giveAwayProducts.find(
                    (product) => product.id == this.selectedGiveAwayProduct.id
                  ) || null
              } else {
                this.selectedGiveAwayProduct = null
              }
            }
          } else {
            vm.$emit('onUpdateTotal', null)
            vm.discount = null
            vm.total = null
            vm.hasVoucherCode = false
            this.giveAwayProducts = []
            this.selectedGiveAwayProduct = null
          }

          vm.loading = false
        } else {
          this.handleErrorVoucher(null)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        this.handleErrorVoucher(error)
      }
    },
    async handleErrorVoucher(error) {
      this.loading = false
      this.discount = null
      this.promocode = null

      this.total = null
      this.hasVoucherCode = false
      this.hasError = true
      this.errorVoucherCode =
        error === 'ALREADY_MARKED_USED'
          ? `${this.$t('Voucher code is already marked used')}`
          : this.pageProfile.type == 'nestle'
          ? 'ขออภัย โค้ดนี้ไม่สามารถใช้ได้เนื่องจากโค้ดอาจจะไม่สามารถใช้ได้แล้ว หรือโค้ดที่คุณเพิ่มไม่ถูกต้อง'
          : `${this.$t('Voucher code is not valid')}`
      await this.$nextTick()
      this.$emit('onUpdateTotal', null)
    },

    async eggCheckCode() {
      this.loading = true
      let url = config.getConfig('serverUrl') + 'egg/check_code'
      axios.defaults.headers.common = {
        'api-key': '1-2-3-sharks-landed'
      }
      try {
        const response = await axios.get(url, {
          params: {
            pageid: this.pageProfile.pageid,
            code: this.promocode
          }
        })

        var vm = this
        var discount = 0
        var sku = null
        var skuPrice = null
        if (response.data.success) {
          if (response.data.result.data.privilegeType === 'sku') {
            this.cart.map((obj) => {
              if (
                obj.id == response.data.result.data.skuId &&
                obj.quantity >= response.data.result.data.quantity
              ) {
                skuPrice = obj.price
                discount =
                  skuPrice * response.data.result.data.quantity -
                  response.data.result.data.totalPrice
                sku = response.data.result
              } else {
                discount = null
              }
            })
          } else {
            if (response.data.result.data.discountType === 'amount') {
              discount = response.data.result.data.amount
            } else if (
              response.data.result.data.discountType === 'percentage'
            ) {
              discount = (
                this.totalEgg * response.data.result.data.amount
              ).toFixed(2)
            }
          }
          if (discount !== null) {
            var dataSet = {
              skuPrice: skuPrice,
              sku: sku,
              discount: discount,
              discountship: 0,
              freeship: false,
              promocode: response.data.result.data.code
            }
            this.$emit('onUpdateTotal', {
              ...dataSet,
              onUpdate: function () {
                vm.onCheckVoucher()
              }
            })
            this.promotion = {
              freeship: false,
              discountship: 0,
              discount: discount,
              sku: sku
            }
            this.hasVoucherCode = true
            this.isInputVoucherCode = false
            this.loading = false
          } else {
            await this.getCalculateWithPromocode(response.data.result.message)
          }
        } else {
          await this.getCalculateWithPromocode(response.data.result.message)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        await this.getCalculateWithPromocode()
        this.loading = false
      }
    },

    async clearpromocodeincart() {
      //     POST /clearpromocodeincart
      // qs : userid,pageid ,sessiontoken
      const vm = this
      vm.loading = true
      let data = {
        userid: vm.userid,
        pageid: vm.pageProfile.pageid,
        sessiontoken: vm.sessiontoken
      }
      let body = {}
      if (vm.$route.query && vm.$route.query.shoptoken) {
        body.shop_token = vm.$route.query.shoptoken
      }
      let response = await axios.post(
        config.getConfig('serverUrl') + 'clearpromocodeincart',
        body,
        { params: data }
      )

      if (
        (response.status == 200 && response.data.responsecode == 200) ||
        (localStorage.getItem('cartarray') && !vm.userid)
      ) {
        vm.hasVoucherCode = false
        vm.promocode = null
        vm.promotion = null
        vm.discount = null
        vm.total = null
        vm.$emit('onUpdateTotal', null)
      }

      vm.giveAwayProducts = []
      vm.$emit('handleSelectedGiveAwayProduct', null)
      vm.loading = false
    },
    async pageConfig() {
      const vm = this
      if (!vm.pageProfile.egg_crm_status) return false
      let data = {
        pageid: vm.pageProfile.pageid
      }
      var response = await axios.get(
        config.getConfig('serverUrl') + 'egg/page_config',
        {
          params: data,
          headers: { 'api-key': '1-2-3-sharks-landed' }
        }
      )
      if (response.data.success) {
        vm.egg_front_url = response.data.result.front_url
      }
    },
    openRedeem() {
      window.open(this.egg_front_url, '_blank')
    }
  },
  watch: {
    value: async function (newVal, oldVal) {
      const vm = this
      vm.initial()
      if (newVal && newVal != oldVal && (oldVal == null || oldVal == '')) {
        vm.promocode = newVal
        await vm.onCheckVoucher()
        //
      } else {
        vm.promocode = null
      }
    }
  }
}
